import axios from "axios";
import { decrypt, encrypt } from "../encryt";
import { Cookie } from "../index";
import Cookies from "js-cookie";
import {
  clearAuthSessionAndRedirect,
  isAuthErrorMessage,
} from "../authSession";

const baseURL = process.env.REACT_APP_URL_CLIENT;
const timeout = 16000;

// let token2 = Cookies.get("token") ? decrypt(Cookie.get({ name: "token" })) : null;
const instance = axios.create({
  baseURL,
  timeout,
  headers: {
    "Content-Type": "application/json",
    // "Authorization": `Bearer ${token2}`
  },
});

instance.interceptors.request.use(async (config) => {
  try {
    const token = Cookies.get("token")
      ? await decrypt(Cookie.get({ name: "token" }))
      : "";

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    } else {
      delete config.headers["Authorization"];
    }

    return config;
  } catch (error) {
    clearAuthSessionAndRedirect();
    return Promise.reject(error);
  }
});

instance.setToken = (token) => {
  instance.defaults.headers["Authorization"] = `Bearer ${token}`;
  Cookie.set({ name: "token", data: encrypt(token) });
};

instance.interceptors.response.use(
  (response) => {
    const message = response?.data?.error || response?.data?.message;

    if (isAuthErrorMessage(message)) {
      clearAuthSessionAndRedirect();
      return Promise.reject(response.data);
    }

    return response;
  },
  async (err) => {
    const error = err.response;
    const message = error?.data?.error || error?.data?.message || err.message;

    if ((error && error.status === 401) || isAuthErrorMessage(message)) {
      clearAuthSessionAndRedirect();
    }

    return Promise.reject(err);
  }
);

export default instance;
